module.exports = __webpack_public_path__ + "img/leftsumo.09639654.png";